import { Menu} from 'antd'
import { MenuProps } from 'antd/lib/menu'
import * as React from 'react'

export type SidebarIconsList = {component: React.ReactNode}[]

export interface VerticalSidebarMenuProps {
	sidebarIconsList: SidebarIconsList
	antdMenuProps?: MenuProps
}
export const VerticalSidebarMenu: React.FC<VerticalSidebarMenuProps> = (props) => {
	const { sidebarIconsList, antdMenuProps } = props

	return (
		<Menu mode='vertical' theme='dark' {...antdMenuProps}>
			{sidebarIconsList.map((icon, index) => {
				const { component } = icon
				return component && <Menu.Item key={index}>{component}</Menu.Item>
			})}
		</Menu>
	)
}